import {
  FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist,
  FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails,
  FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistStatusEnum,
  FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner,
  FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser
} from '@/types/crm-screener-api';

export enum LeadWaitlistStatus {
  Waitlisted = 'Waitlisted',
  Cleared = 'Cleared',
  Cancelled = 'Cancelled'
}

export class LeadWaitlistModel
  implements
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist
{
  created_at?: string | undefined;
  details?:
    | FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails
    | undefined;
  id?: string | undefined;
  lead_id?: string | undefined;
  rank?: number | undefined;
  receipt_id?: string | undefined;
  status?:
    | FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistStatusEnum
    | undefined;
  status_set_by_user?:
    | FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser
    | undefined;
  updates?:
    | FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner[]
    | undefined;
  constructor(
    payload: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist
  ) {
    Object.assign(this, payload);
  }
}
